import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Website from './Website';

const enableStrictMode = false;
const element = document.getElementById('root')!;
const app = enableStrictMode ? <StrictMode><Website /></StrictMode> : <Website />;

if (import.meta.hot) {
    // With hot module reloading, `import.meta.hot.data` is persisted.
    const root = (import.meta.hot.data.root ??= createRoot(element));
    root.render(app);
}
else {
    // The hot module reloading API is not available in production.
    createRoot(element).render(app);
}